var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrmIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2b69b3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,11.26a1.5,1.5,0,0,0,1.5-1.5V5a1.5,1.5,0,0,0-3,0V9.76a1.5,1.5,0,0,0,1.5,1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.58,17.3a1.5,1.5,0,0,0,1.06-.44L51,13.49a1.51,1.51,0,0,0,.33-.49,1.53,1.53,0,0,0,0-1.14,1.51,1.51,0,0,0-.33-.49,1.52,1.52,0,0,0-2.12,0l-3.36,3.37a1.51,1.51,0,0,0-.33.49,1.53,1.53,0,0,0,0,1.14,1.52,1.52,0,0,0,1.39.93Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.38,28.88H52.62a1.5,1.5,0,0,0,0,3h4.76a1.5,1.5,0,0,0,0-3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.64,43.9a1.5,1.5,0,0,0-.48-.39,1.43,1.43,0,0,0-.6-.17,1.47,1.47,0,0,0-.62.1,1.4,1.4,0,0,0-.52.33A1.5,1.5,0,0,0,45,44.91a1.53,1.53,0,0,0,.16.6,1.44,1.44,0,0,0,.39.49l3.36,3.36a1.5,1.5,0,0,0,1.06.44,1.43,1.43,0,0,0,.82-.26,1.46,1.46,0,0,0,.54-.66,1.41,1.41,0,0,0,.09-.86,1.5,1.5,0,0,0-.39-.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.36,43.9,13,47.26a1.52,1.52,0,0,0-.41.77,1.41,1.41,0,0,0,.09.86,1.47,1.47,0,0,0,.55.68,1.5,1.5,0,0,0,1.89-.19L18.48,46a1.42,1.42,0,0,0,.35-.49,1.63,1.63,0,0,0,.13-.58,1.71,1.71,0,0,0-.11-.59,1.49,1.49,0,0,0-.83-.83,1.71,1.71,0,0,0-.59-.11,1.63,1.63,0,0,0-.58.13,1.42,1.42,0,0,0-.49.35Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.38,28.88H6.62a1.5,1.5,0,0,0,0,3h4.76a1.5,1.5,0,0,0,0-3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.36,16.86a1.51,1.51,0,0,0,2.45-.49,1.53,1.53,0,0,0,0-1.14,1.51,1.51,0,0,0-.33-.49l-3.36-3.37a1.52,1.52,0,0,0-2.12,0,1.51,1.51,0,0,0-.33.49,1.53,1.53,0,0,0,0,1.14,1.51,1.51,0,0,0,.33.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.46,29A16.52,16.52,0,1,0,21.21,42.88,10.78,10.78,0,0,1,25,51v.7a1.5,1.5,0,0,0,1.5,1.5h.76v2.55a4.74,4.74,0,0,0,9.48,0V53.21h.76a1.5,1.5,0,0,0,1.5-1.5V51a11,11,0,0,1,3.88-8.21A16.44,16.44,0,0,0,48.46,29ZM33.74,55.76a1.74,1.74,0,0,1-3.48,0V53.21h3.48Zm7.17-15.22A14.1,14.1,0,0,0,36,50.21H28a13.75,13.75,0,0,0-4.81-9.6,13.53,13.53,0,1,1,17.74-.07Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIcon1);
export default __webpack_public_path__ + "static/media/crm_icon_1.4e9b2dc513f0c3f91c74b35d682df8c2.svg";
export { ForwardRef as ReactComponent };